module.exports = __webpack_public_path__ + "assets/img/return.ab190822.png";